var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTasks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 14.25V11.625C20 10.7299 19.6444 9.87145 19.0115 9.23851C18.3786 8.60558 17.5201 8.25 16.625 8.25H15.125C14.8266 8.25 14.5405 8.13147 14.3295 7.9205C14.1185 7.70952 14 7.42337 14 7.125V5.625C14 4.72989 13.6444 3.87145 13.0115 3.23851C12.3785 2.60558 11.5201 2.25 10.625 2.25H8.75M8.75 15H16.25M8.75 18H12.5M11 2.25H6.125C5.504 2.25 5 2.754 5 3.375V20.625C5 21.246 5.504 21.75 6.125 21.75H18.875C19.496 21.75 20 21.246 20 20.625V11.25C20 8.86305 19.0518 6.57387 17.364 4.88604C15.6761 3.19821 13.3869 2.25 11 2.25Z",
    stroke: "#525355",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/Tasks.2a2d4ac6a1fc699f18802a3eb2fcd45e.svg";
export { ForwardRef as ReactComponent };